import {Number4} from '../../../../../types/GlobalTypes';
export class QuadNode {
	constructor(public readonly id: number, public readonly indices: Number4) {}
}
